import React, { useRef } from "react";
import PropTypes from "prop-types";
import { NumericFormat } from "react-number-format";

const InputNumber = (props) => {
  const { disabled = false, addonBefore = "", value = 0, min = 0 } = props;
  const onValueChange = (value) => {
    const newValue = value.floatValue ? value.floatValue : 0;
    _onChange(newValue);
  };

  const normalizeValue = (inputValue) => {
    const normalized = inputValue.replaceAll('.','').replace(',', '.').replace(/[^\d.]/g, '');
    return parseFloat(normalized);
  };

  const _onChange = (value) => {
    if (props.onChange) {
      props.onChange(value);
    }
  };

  return (
    <span className="input-currency-group-wrapper">
      <span className="input-currency-wrapper">
        <span
          className={`input-currency-group-addon ${
            disabled ? "input-currency-group-addon-disabled" : ""
          }`}
        >
          {addonBefore}
        </span>
        <NumericFormat
          min={min}
          className="input-currency"
          decimalSeparator={","}
          fixedDecimalScale={true}
          decimalScale={2}
          value={value}
          displayType={"input"}
          thousandSeparator={"."}
          prefix={""}
          onFocus={(x) => x.target.select()}
          onValueChange={({ formattedValue, floatValue }) => {
            const newValue = floatValue ? floatValue : normalizeValue(formattedValue);
            _onChange(newValue);
          }}
          onBlur={(e) => {
            const newValue = normalizeValue(e.target.value);
            _onChange(newValue);
          }}
          disabled={disabled}
        />
      </span>
    </span>
  );
};

InputNumber.propTypes = {
  value: PropTypes.number,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  addonBefore: PropTypes.string,
};

const InputCurrency = (props) => {
  const { disabled = false, addonBefore } = props;

  return <InputNumber {...props} disabled={disabled} addonBefore={ addonBefore? addonBefore: "R$" } />;
};

InputCurrency.propTypes = {
  defaultValue: PropTypes.number,
  value: PropTypes.number,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};

export { InputCurrency, InputNumber };
